"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _ChatActionTypes = require("../constants/action-types/ChatActionTypes");

var types = _interopRequireWildcard(_ChatActionTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var initialState = {
  messages: [],
  isMaximised: false,
  unseenMessages: 0
};

exports.default = function () {
  var chat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case types.SET_CHAT_STATE:
      return setState(payload);

    case types.ADD_MESSAGE:
      return addMessage(chat, payload);

    case types.MAXIMISE_CHAT:
      return maximiseChat(chat);

    case types.MINIMISE_CHAT:
      return minimiseChat(chat);

    default:
      return chat;
  }
}; // TODO: Originally this was a deepMerge of chat and payload state, does this new func still work?


var setState = function setState(_ref2) {
  var state = _ref2.state;
  return state;
};

var addMessage = function addMessage(chat, _ref3) {
  var playerName = _ref3.playerName,
      playerId = _ref3.playerId,
      text = _ref3.text;
  var message = {
    playerName: playerName,
    playerId: playerId,
    text: text
  };
  var isMaximised = chat.isMaximised,
      unseenMessages = chat.unseenMessages,
      messages = chat.messages;
  return _extends({}, chat, {
    messages: [].concat(_toConsumableArray(messages), [message]),
    unseenMessages: !isMaximised ? unseenMessages + 1 : 0
  });
};

var maximiseChat = function maximiseChat(chat) {
  return _extends({}, chat, {
    isMaximised: true,
    unseenMessages: 0
  });
};

var minimiseChat = function minimiseChat(chat) {
  return _extends({}, chat, {
    isMaximised: false
  });
};